module.exports = __webpack_public_path__ + "img/baggage_9e204d2.webp";